module.exports = __webpack_public_path__ + "static/media/tiff-icon.5362c787.svg";